// src/api/orderApi.js
import apiClient from "./axios";

const orderApi = {
  // GET all orders (with pagination + search)
  // getAll: async (page = 1, pageSize = 10, search = '') => {
  //   const response = await apiClient.get('/orders/', {
  //     params: { page, page_size: pageSize, search },
  //   });
  //   return response.data; // { data: [...], pagination: { ... } }
  // },

  getAll: async (filters = {}) => {
    // Default values (you can override them by passing in filters)
    const defaultParams = {
      page: 1,
      page_size: 10,
      search: "",
    };

    // Merge defaults with provided filters
    const params = { ...defaultParams, ...filters };

    // Special handling: employee is only added if explicitly passed
    // (keeps backward compatibility with canteen-specific logic)
    if (filters.employee !== undefined) {
      params.employee = filters.employee;
    }

    const response = await apiClient.get("/orders/", { params });
    return response.data;
  },

  //   getAll: async (filters = {}) => {
  //   const response = await apiClient.get('/orders/', {
  //     params: filters,
  //   });
  //   return response.data;
  // },

  // GET single order
  getById: async (id) => {
    const response = await apiClient.get(`/orders/${id}/`);
    return response.data;
  },

  // PLACE ORDER
  placeOrder: async (items) => {
    const response = await apiClient.post("/orders/", { items });
    return response.data;
  },

  // CANCEL ORDER (only if pending)
  // cancelOrder: async (id) => {
  //   const response = await apiClient.post(`/orders/${id}/cancel/`);
  //   return response.data;
  // },

  cancelOrder: async (id, reason = null) => {
    const payload = reason ? { reason } : {}; // backend expects { "reason": "..." }
    const response = await apiClient.post(`/orders/${id}/cancel/`, payload);
    return response.data;
  },

  // UPDATE STATUS (admin only)
  updateStatus: async (id, status) => {
    const response = await apiClient.patch(`/orders/${id}/status/`, { status });
    return response.data;
  },

  // SUBMIT FEEDBACK
  submitFeedback: async (id, rating, comment = "") => {
    const response = await apiClient.post(`/orders/${id}/feedback/`, {
      rating,
      comment,
    });
    return response.data;
  },

  // SOFT DELETE
  deleteOrder: async (id) => {
    await apiClient.delete(`/orders/${id}/`);
  },
};

export default orderApi;